@if (products$ | async; as products) {
    <div>
        @if (category$ | async; as category) {
            <div>
                <div class="container-fluid container-xxl overflow-hidden gx-sm-9 gx-lg-10 gx-xxl-0">
                    <div class="row">
                        <div class="col-xl-3 d-flex flex-column justify-content-center word-wrap-break-word">
                            <h3 class="mb-xl-9 mb-5 fs-12 fw-700 ls-2 font-secondary text-secondary text-uppercase">
                                {{ category.name }}
                            </h3>
                            @if (category.description) {
                                <div>
                                    <p class="mb-7 lh-29">{{ category.description }}</p>
                                </div>
                            } @else {
                                <p class="mb-7 lh-29">{{ 'NEW_ARRIVALS.teaser' | translate }}</p>
                            }
                            <div class="d-none d-xl-block">
                                <app-button [url]="['products', 'category', category.slug] | localize">{{ 'BUTTONS.see_all' | translate }}</app-button>
                            </div>
                        </div>
                        <div class="col-xl-9">
                            <div class="d-none d-md-block">
                                <div #swiper class="swiper" [class.is-client]="isClient">
                                    <div class="swiper-wrapper">
                                        @for (product of products; track product.slug) {
                                            <div class="swiper-slide">
                                                <a [routerLink]="['/products', 'category', category.slug, product.slug] | localize">
                                                    <div app-product-thumbnail [product]="product"></div>
                                                </a>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div #swiperPagination class="new-arrivals-pagination pagination mt-6"></div>
                            </div>
                            <div class="d-md-none">
                                <div class="row gx-0 gx-md-4 gy-4">
                                    @for (product of products; track product) {
                                        <div class="col-6">
                                            <a [routerLink]="['/products', 'category', category.slug, product.slug] | localize">
                                                <div class="item" app-product-thumbnail [product]="product"></div>
                                            </a>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-block d-xl-none mb-8 mt-5 mt-md-0">
                        <app-button [url]="['/products', 'category', category.slug] | localize">{{ 'BUTTONS.see_all' | translate }}</app-button>
                    </div>
                </div>
            </div>
        }
    </div>
} @else {
    <div class="spinner mx-auto"></div>
}
